import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["vagasInternet", "vagasLote", "capacidadeTotal"]

  connect() {
    this.update()
  }

  update() {
    const total = this.vagasInternet + this.vagasLote
    this.capacidadeTotalTarget.textContent = total

    this.capacidadeTotalTarget.classList.toggle('bg-success', total > 0)
    this.capacidadeTotalTarget.classList.toggle('bg-secondary', total === 0)
  }

  // Esses getters garantem valores inteiros, mesmo se o campo estiver vazio
  get vagasInternet() {
    return parseInt(this.vagasInternetTarget.value, 10) || 0
  }

  get vagasLote() {
    return parseInt(this.vagasLoteTarget.value, 10) || 0
  }
}
